<p>check-out-promo-codes works!</p>
